// extracted by mini-css-extract-plugin
export var center = "_4b-2";
export var clickableRow = "_4b-5";
export var expandedRow = "_4b-7";
export var hoverable = "_4b-4";
export var left = "_4b-1";
export var right = "_4b-3";
export var row = "_4b-0";
export var selectedRow = "_4b-6";
export var summaryRow = "_4b-8";